import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Public client — no auth header
const publicApi = axios.create({ baseURL: API });

export default publicApi;
